import React from 'react';

const ThreeColCta = ({
	ImgSrc1,
	ContentTitle1,
	ContentCopy1,
	Url1,
	ImgSrc2,
	ContentTitle2,
	ContentCopy2,
	Url2,
	ImgSrc3,
	ContentTitle3,
	ContentCopy3,
	Url3
}) => {
	return (
		<div className="c-three-col-cta">
			<a href={Url1} className="c-three-col-cta__col" style={{ backgroundImage: `url(${ImgSrc1})` }}>
				<div className="c-three-col-cta__content">
					<p className="c-three-col-cta__content-title">{ContentTitle1}</p>
					<p className="c-three-col-cta__content-copy">{ContentCopy1}</p>
					<p className="c-three-col-cta__content-learn-more">Learn more</p>
				</div>
			</a>
			<a href={Url2} className="c-three-col-cta__col" style={{ backgroundImage: `url(${ImgSrc2})` }}>
				<div className="c-three-col-cta__content">
					<p className="c-three-col-cta__content-title">{ContentTitle2}</p>
					<p className="c-three-col-cta__content-copy">{ContentCopy2}</p>
					<p className="c-three-col-cta__content-learn-more">Learn more</p>
				</div>
			</a>
			<a href={Url3} className="c-three-col-cta__col" style={{ backgroundImage: `url(${ImgSrc3})` }}>
				<div className="c-three-col-cta__content">
					<p className="c-three-col-cta__content-title">{ContentTitle3}</p>
					<p className="c-three-col-cta__content-copy">{ContentCopy3}</p>
					<p className="c-three-col-cta__content-learn-more">Learn more</p>
				</div>
			</a>
		</div>
	);
};

export default ThreeColCta;
